import React, {  useEffect, useState, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"   
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box';    
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingViewsPurchase from "pages/forms/filterFormDI/FormDIPurchaseView/SortingTablesFormDIPurchase";
import ReportPurchaseSignature from "pages/forms/filterFormDI/FormDIPurchaseView/ReportPurchaseView";
import PropTypes from 'prop-types';
  
const initialStatePurchase = [{
  "id" : 0,
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "",
  "defaultformatnumber":1,
  "isfinished":false, 
  "purchasenote":0, 
  "numberticket":0, 
  "ownnumberpurchase":"", 
  "datepurchase": null, 
  "vehiclestore_id": 0,
  "vehiclestore_licenseplate": "",
  "vehiclestore_defaultdriver": "",
  "vehiclestore_store_id": 0,
  "rel_trans_store_id": 0,
  "rel_trans_documnettype_id": 0,
  "rel_trans_documentid": "",
  "rel_trans_documnettype_name": "",
  "rel_trans_tradename": "",
  "rel_trans_name": "",
  "rel_trans_contacperson": "",
  "rel_trans_nima": "",
  "rel_trans_pygr": "",
  "rel_trans_grnp":"",
  "rel_trans_opt": 0,
  "rel_trans_roadtype_id": 0,
  "rel_trans_street": "",
  "rel_trans_country_id": 1,
  "rel_trans_province_id": 30,
  "rel_trans_postalcode_id": 0,
  "ori_tras_store_id": 0,
  "ori_tras_documnettype_id": 0,
  "ori_tras_documnettype_name": "",
  "ori_tras_documentid": "",
  "ori_tras_tradename": "",
  "ori_tras_name": "",
  "ori_tras_contacperson": "",
  "ori_tras_nima": "",
  "ori_tras_pygr": "",
  "ori_tras_grnp":"",
  "ori_tras_opt": 0,
  "ori_tras_workplace": "",
  "ori_tras_roadtype_id": 0,
  "ori_tras_street": "",
  "ori_tras_country_id": 1,
  "ori_tras_province_id": 30,
  "ori_tras_postalcode_id": 0,
  "ori_tras_email": "",

  "observations": "",
  "totalpurchasedelivery": 0,
  "totaldiscountpurchasedelivery": 0,
  "totaltaxespurchasedelivery":0,
  "totalNetoPurchasedelivery":0,
  "enabled":true,
  "subownnumberpurchase":0,
  "payment_id" : 0 ,
  "payment_code": "",
  "payment_namees": "",
  "payment_nameen": "",
  "totalWeigthNeto":0,
  "signature_dispatched_by":"",
  "signature_client":"",
  "linespurchasedelivery":[]
}];   
 

const FormDIPurchase = ({ openViewPurchase, setOpenViewPurchase,rowEditFormDI}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token); 
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesizetickes);
  const [dataPurchase, setDataPurchase] = useState(initialStatePurchase);
  const [isLoadingErrorPurchase, setIsLoadingErrorPurchase] = useState(false);
  const isLoading = useSelector((state) => state.loading.isLoading);  
  const [numTotRegPurchase,setNumTotRegPurchase]= useState(0);
  const [activeOffsetPurchase, setActiveOffsetPurchase]= useState(false);
  const [currencyOffsetPurchase, setCurrencyOffsetPurchase] = useState(0);
  const [rangeOffsetPurchase, setRangeOffsetPurchase] = useState([{}]); 
  const [pdfBlob, setPdfBlob] = useState(null); 
  const dispatch = useDispatch(); 
   
  const handleCloseDataViewPurchase = () => {
    setDataPurchase(initialStatePurchase);
    setIsLoadingErrorPurchase(false);
    dispatch(setLoading(false)); 
    setNumTotRegPurchase(0);
    setActiveOffsetPurchase(false);
    setCurrencyOffsetPurchase(0);
    setRangeOffsetPurchase([{}]);  
    setPdfBlob(null);
    setOpenViewPurchase(false)
	};
   
  const PdfViewer = useMemo(() => {
    return pdfBlob ? (
      <iframe
        src={URL.createObjectURL(pdfBlob)}
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    ) : null;
  }, [pdfBlob]);
  
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegPurchase = async () => { 
      try {
        const getData  = await helpHttp().get2(ENDPOINT,`form/getinformationpurchasebyformid/`,token,rowEditFormDI.id);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          } 
        } else if (isMounted) { 
          setNumTotRegPurchase(getData); 
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        dispatch(setLoading(false)); 
      }
    };

    const fetchdataPurchase = async () => {
      try {
        dispatch(setLoading(false));
        const getData = await helpHttp().get7(ENDPOINT,`form/getlistpurchaseformdibyid`,token,currencyOffsetPurchase,LIMITPAGESIZE,rowEditFormDI.id);
        if (getData.err) {
          dispatch(setLoading(false));
          setDataPurchase(initialStatePurchase);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          if(isMounted){
            setDataPurchase(getData);
          } 
          dispatch(setLoading(false)); 
        } 
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }; 

    if (openViewPurchase){  
      fetchnumTotRegPurchase(); 
      fetchdataPurchase();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,LIMITPAGESIZE,currencyOffsetPurchase,openViewPurchase,rowEditFormDI.id]);
  
  const toggleDrawerSearchFormDI  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataViewPurchase();
    }
  }; 

  return(
    <>
      {openViewPurchase && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormDI(false)}
            onOpen={toggleDrawerSearchFormDI(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '1150px'}}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                  {isLoadingErrorPurchase?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoading?<CircularProgress color={"primary"}/>:<i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_FORM_NUM_DI')+": "+rowEditFormDI.ownformdi_id}</h1>
                     <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataViewPurchase} >{t('Button_Back')}</button><> </>
                    </div>  
                </div>  
                <br/>  
                {!isLoading ?
                  <>
                   <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                      <TableSortingViewsPurchase
                        dataPurchase={dataPurchase} 
                        titleTable={"Text_FORM_ASSOCIATES_PURCHASE"}
                        numTotRegPurchase={numTotRegPurchase}
                        activeOffsetPurchase={activeOffsetPurchase}
                        rangeOffsetPurchase={rangeOffsetPurchase}
                        currencyOffsetPurchase={currencyOffsetPurchase}
                        setCurrencyOffsetPurchase={setCurrencyOffsetPurchase} 
                      >
                      </TableSortingViewsPurchase>
                      </div>             
                    </div>
                    {/* PDF CARD */}
                    <div className="email-card-pdf">
                      {PdfViewer}
                    </div>
                     
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                } 
              </Box>
              <ReportPurchaseSignature 
                dataPurchase={dataPurchase}  
                setPdfBlob={setPdfBlob} 
              />
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

FormDIPurchase.propTypes = {
  openViewPurchase: PropTypes.bool.isRequired,
  setOpenViewPurchase: PropTypes.func.isRequired 
};

export default FormDIPurchase;

